import { Button, Card, Col, Row, Space, Typography } from "antd";
import React, { useState } from "react";
import StatCard from "./StatCard";
import { CheckCircleOutlined, PlusOutlined, StarOutlined, TrophyOutlined } from "@ant-design/icons";
import TargetCard from "./TargetCard";
import { useFetchAchievementSummary, useFetchActiveTargetsList, useFetchMetricsList, useFetchOfficeUsers, useFetchRewardTypesAndPeriods } from "./hooks/getHooks";
import ModalCreateTarget from "./ModalCreateTarget";
import { formatDate, isNotEmpty } from "../../utils";
import { targetsController } from "./controller";
import ModalEditTarget from "./ModalEditTarget";

const { Title, Text } = Typography;


const Overview =({}) => {

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedTarget, setSelectedTarget] = useState(null);

  const {activeTargetsList, refetch} = useFetchActiveTargetsList();
  const {metricsList} = useFetchMetricsList()
  const {officeUsers} = useFetchOfficeUsers();
  const {rewardTypes, periods} = useFetchRewardTypesAndPeriods()
  const {achievementSummary} = useFetchAchievementSummary();

  console.log("selectedTarget", selectedTarget)

  const handleDelete = async (ruleId) => {
    await targetsController.removeTaget(ruleId);
    refetch();
  };

  return (
    <>
      {/* Stat Cards */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} sm={12} lg={8} xxl={4}>
          <StatCard
            title="Active Targets"
            value={achievementSummary && achievementSummary.current_month && achievementSummary.current_month.active_targets_count }
            icon={<StarOutlined />}
            bg="#f5f0ff"
          />
        </Col>

        <Col xs={24} sm={12} lg={8} xxl={4}>
          <StatCard
            title="Completed This Month"
            value={achievementSummary && achievementSummary.current_month && achievementSummary.current_month.completed_this_month }
            icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
            bg="#f6ffed"
          />
        </Col>

        <Col xs={24} sm={12} lg={8} xxl={4}>
          <StatCard
            title="Total Points Earned"
            value={achievementSummary && achievementSummary.reward_accumulation_all_time && achievementSummary.reward_accumulation_all_time.points}
            icon={<StarOutlined style={{ color: "#1677ff" }} />}
            bg="#e6f4ff"
          />
        </Col>

        <Col xs={24} sm={12} lg={8} xxl={4}>
          <StatCard
            title="Badges Earned"
            value={achievementSummary && achievementSummary.reward_accumulation_all_time && achievementSummary.reward_accumulation_all_time.badge}
            icon={<TrophyOutlined style={{ color: "#faad14" }} />}
            bg="#fff7e6"
          />
        </Col>

        <Col xs={24} sm={12} lg={8} xxl={4}>
          <StatCard
            title="Monetaries Earned"
            value={achievementSummary && achievementSummary.reward_accumulation_all_time && achievementSummary.reward_accumulation_all_time.monetary}
            icon={<TrophyOutlined style={{ color: "#faad14" }} />}
            bg="#fff7e6"
          />
        </Col>
                <Col xs={24} sm={12} lg={8} xxl={4}>
          <StatCard
            title="Recognitions Earned"
            value={achievementSummary && achievementSummary.reward_accumulation_all_time && achievementSummary.reward_accumulation_all_time.recognition}
            icon={<TrophyOutlined style={{ color: "#faad14" }} />}
            bg="#fff7e6"
          />
        </Col>
      </Row>

      {/* Active Targets Section */}
      <Card
        style={{ marginTop: 24, borderRadius: 16 }}
        bodyStyle={{ padding: 24 }}
      >
        <Space
          style={{
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 48,
          }}
        >
          <Title level={4} style={{ margin: 0, fontWeight: 400 }}>
            Active Targets
          </Title>

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsCreateModalOpen(true)}
            style={{ borderRadius: 8, backgroundColor: "#9810fa", padding: "8px 12px" }}
          >
            Create Target
          </Button>
        </Space>

        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          {isNotEmpty(activeTargetsList) && isNotEmpty(activeTargetsList.active_targets) &&
            activeTargetsList.active_targets.map((target) => (
              <TargetCard
                key={target.id}
                title={target.rule_name}
                date={`${formatDate(target.start_date)} - ${formatDate(target.end_date)}`}
                actions={target.actions}
                reward={`Earn ${target.reward_amount} ${target.reward_type}${target.reward_type == "points" ? '' : 's'} for achieving the target`}
                members={target.users_count}
                onDelete={() => handleDelete(target.id)}
                onEdit={() => {
                  setSelectedTarget(target);   // 👈 store full object
                  setIsEditModalOpen(true);
                }}
              />
            ))

          }

        </Space>
      </Card>

      <ModalCreateTarget
        open={isCreateModalOpen}
        onCancel={() => setIsCreateModalOpen(false)}
        onSuccess={() => {
          setIsCreateModalOpen(false);
          refetch();
        }}
        data={{metricsList, rewardTypes, periods, officeUsers}}
      />

      <ModalEditTarget
        open={isEditModalOpen}
        onCancel={() => {
          setIsEditModalOpen(false);
          setSelectedTarget(null);
        }}
        onSuccess={() => {
          setIsEditModalOpen(false);
          setSelectedTarget(null);
          refetch();
        }}
        target={selectedTarget}
        data={{ metricsList, rewardTypes, periods, officeUsers }}
      />
    </>
  )
}
export default Overview;